import React from 'react'
import { LayoutBand, Separator, Paragraph, usePageWidth, H3, Row, Image } from '@fs/zion-ui'

export default function CreateError({ errorInfo }) {
  return (
    <LayoutBand maxWidth="sm">
      <AddSeparator />
      <Separator size="xxl" />
      <Row alignX="center">
        <Image src={errorInfo.image} maxWidth="560px" alt="" />
      </Row>
      <Separator size="md" />
      <H3 centered>{errorInfo.heading}</H3>
      <Separator size="nano" />
      {errorInfo.paragraph && <Paragraph centered>{errorInfo.paragraph}</Paragraph>}
      {errorInfo.trans && <Paragraph centered>{errorInfo.trans}</Paragraph>}
      <Separator size="xl" />
      <AddSeparator />
    </LayoutBand>
  )
}

export function AddSeparator() {
  const atPageWidth = usePageWidth()
  return (
    <>
      {atPageWidth({
        default: (
          <div>
            <Separator size="xxl" />
          </div>
        ),
        lg: null,
      })}
    </>
  )
}
